import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { ChevronDown, ChevronUp, Trash2 } from 'lucide-react';
import type { AttributeGroup, SectionPath } from '../../utils/tree';

interface SectionValueCellProps {
  section: AttributeGroup;
  path: SectionPath;
  depth: number;
  totalSiblings: number;
  attributeName: string;
  disabled: boolean;
  onValueChange: (path: SectionPath, value: string) => void;
  onMove: (path: SectionPath, direction: 1 | -1) => void;
  onRemove: (path: SectionPath) => void;
}

export const SectionValueCell: React.FC<SectionValueCellProps> = ({
  section,
  path,
  depth,
  totalSiblings,
  attributeName,
  disabled,
  onValueChange,
  onMove,
  onRemove,
}) => {
  const indexInParent = path[path.length - 1]!;
  const canMoveUp = indexInParent > 0;
  const canMoveDown = indexInParent < totalSiblings - 1;
  const placeholder = `e.g. ${depth === 0 ? 'Black' : depth === 1 ? '12g' : 'Variant'}`;
  return (
    <div className="d-flex align-items-center gap-2">
      <span className="pgte-reorder-controls" aria-label="Reorder">
        <button
          type="button"
          className="pgte-reorder-button"
          onClick={() => onMove(path, -1)}
          disabled={disabled || !canMoveUp}
          title="Move up"
          aria-label="Move up"
        >
          <ChevronUp size={12} />
        </button>
        <button
          type="button"
          className="pgte-reorder-button"
          onClick={() => onMove(path, 1)}
          disabled={disabled || !canMoveDown}
          title="Move down"
          aria-label="Move down"
        >
          <ChevronDown size={12} />
        </button>
      </span>
      <Form.Control
        size="sm"
        type="text"
        value={section.value}
        disabled={disabled}
        onChange={(event) => onValueChange(path, event.target.value)}
        placeholder={placeholder}
      />
      <Button
        variant="outline-danger"
        size="sm"
        title={`Remove this ${attributeName || 'section'}`}
        onClick={() => onRemove(path)}
        disabled={disabled}
      >
        <Trash2 size={12} />
      </Button>
    </div>
  );
};
